import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';

import * as mobileDeviceFromUserAgent from 'helpers/mobileDeviceFromUserAgent';
import VideoPlayer from 'hb-react/frontoffice/components/VideoPlayer';
import UserList from 'hb-react/frontoffice/components/UserList';

import Partners from '../components/Partners';
import Links from '../components/Links';
import Followings from '../components/Followings';
import LinkedEvents from '../components/LinkedEvents';

const TopicHomeGeneralInfosContainer = (props) => {
  const {
    link_store,
    partner_store,
    expert_store,
    following_store,
    linked_event_store,
    topic,
  } = props;

  return (
    <div className={mobileDeviceFromUserAgent.any() ? 'soft' : ''}>
      {topic.video_url && <VideoPlayer controls url={topic.video_url} />}

      {topic.description && (
        <section className="bordered--top soft-half--bottom soft-double-half bordered--sides bordered--bottom">
          <h2 className="h2 push-half--bottom">
            {I18n.t('web.topics.description')}
          </h2>
          <div>
            <div dangerouslySetInnerHTML={{ __html: topic.description }} />
          </div>
        </section>
      )}

      {!isEmpty(topic.partners) && (
        <Partners
          title={get(
            topic,
            ['home_config', 'section_partners_title'],
            __('Partners'),
          )}
          partners={topic.partners.map((partnerId) =>
            partner_store.getIn(['partners', partnerId.toString()]),
          )}
        />
      )}

      {!isEmpty(topic.experts) && (
        <section className="soft-half--bottom soft-double-half bordered--sides bordered--bottom">
          <h2 className="h2">
            {topic.expert_title ||
              I18n.t('web.topics.experts', { count: topic.experts.length })}
          </h2>
          <UserList
            users={topic.experts.map((expertId) =>
              expert_store.getIn(['experts', expertId.toString()]).toJS(),
            )}
            showDescription
          />
        </section>
      )}

      {/* Used for mobile view */}
      {!isEmpty(topic.followings) && (
        <Followings
          followings={topic.followings.map((followingId) =>
            following_store.getIn(['followings', followingId.toString()]),
          )}
          total={following_store.get('total')}
          topic_id={topic.id}
          sidebar_rendering
        />
      )}

      {!isEmpty(topic.linked_events) && (
        <LinkedEvents
          linked_events={topic.linked_events.map((eventId) =>
            linked_event_store.getIn(['linked_events', eventId.toString()]),
          )}
        />
      )}

      {!isEmpty(topic.links) && (
        <Links
          links={topic.links.map((linkId) =>
            link_store.getIn(['links', linkId.toString()]),
          )}
          link_type="front_links"
        />
      )}
    </div>
  );
};

TopicHomeGeneralInfosContainer.propTypes = {
  topic: PropTypes.object.isRequired,
};

TopicHomeGeneralInfosContainer.defaultProps = {
  topic: {},
};

const mapStateToProps = (state) => ({
  link_store: state.links,
  partner_store: state.partners,
  expert_store: state.experts,
  following_store: state.followings,
  linked_event_store: state.linked_events,
});

export default connect(mapStateToProps)(TopicHomeGeneralInfosContainer);
